// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_SetString from "rescript/lib/es6/belt_SetString.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

function storageKey(view, userId) {
  var v = view !== undefined ? view : "default";
  var uid = userId !== undefined && userId !== "" ? userId : "anon";
  return "gdc_" + v + "_list_columns_v1:" + uid;
}

function parseCsv(csv) {
  if (csv !== undefined) {
    if (csv === "") {
      return [];
    } else {
      return Belt_Array.keepMap(csv.split(","), (function (part) {
                    var trimmed = part.trim();
                    if (trimmed === "") {
                      return ;
                    } else {
                      return trimmed;
                    }
                  }));
    }
  } else {
    return [];
  }
}

function decodeStringArray(json) {
  var items = Js_json.decodeArray(json);
  if (items !== undefined) {
    return Belt_Array.keepMap(items, Js_json.decodeString);
  } else {
    return [];
  }
}

var allowedSet = Belt_SetString.fromArray;

function filterAllowed(columns, allowed) {
  return Belt_Array.keep(columns, (function (col) {
                return Belt_SetString.has(allowed, col);
              }));
}

function mounted() {
  var self = this ;
  var element = self.el;
  var value = element.getAttribute("data-view");
  var view = !(value == null) ? value : undefined;
  var value$1 = element.getAttribute("data-user-id");
  var userId = !(value$1 == null) ? value$1 : undefined;
  var allowed = Belt_SetString.fromArray((function (csv) {
            return parseCsv(csv);
          })(DomEl$GameDataCore.data(element, "all-columns")));
  var key = storageKey(view, userId);
  try {
    var raw = localStorage.getItem(key);
    if (raw == null) {
      return ;
    }
    var columns = filterAllowed(decodeStringArray(JSON.parse(raw)), allowed);
    if (columns.length !== 0) {
      self.pushEvent("restore-columns", {
            columns: columns
          });
      return ;
    } else {
      return ;
    }
  }
  catch (exn){
    return ;
  }
}

function updated() {
  var self = this ;
  var element = self.el;
  var value = element.getAttribute("data-view");
  var view = !(value == null) ? value : undefined;
  var value$1 = element.getAttribute("data-user-id");
  var userId = !(value$1 == null) ? value$1 : undefined;
  var key = storageKey(view, userId);
  var cols = parseCsv(DomEl$GameDataCore.data(element, "list-columns"));
  if (cols.length === 0) {
    return ;
  }
  try {
    localStorage.setItem(key, JSON.stringify(cols));
    return ;
  }
  catch (exn){
    return ;
  }
}

var columnPickerPersist = {
  mounted: mounted,
  updated: updated
};

export {
  storageKey ,
  parseCsv ,
  decodeStringArray ,
  allowedSet ,
  filterAllowed ,
  mounted ,
  updated ,
  columnPickerPersist ,
}
/* mounted Not a pure module */
